var map = {
	"./developer-icon.svg": 3457,
	"./full_stack_banner.avif": 4591,
	"./github.svg": 2405,
	"./icons8-bootstrap.svg": 8884,
	"./icons8-c-sharp-logo.svg": 4606,
	"./icons8-c.svg": 123,
	"./icons8-cc.svg": 6434,
	"./icons8-css.svg": 2300,
	"./icons8-html.svg": 2093,
	"./icons8-java.svg": 7289,
	"./icons8-javascript.svg": 6373,
	"./icons8-mysql.svg": 7240,
	"./icons8-nodejs.svg": 9089,
	"./icons8-spring-boot.svg": 760,
	"./icons8-vue-js.svg": 1962,
	"./logo.png": 6949,
	"./png/logo-black.png": 8525,
	"./png/logo-color.png": 6748,
	"./png/logo-no-background.png": 5714,
	"./png/logo-white.png": 4976,
	"./svg/logo-black.svg": 6861,
	"./svg/logo-color.svg": 2402,
	"./svg/logo-no-background.svg": 6849,
	"./svg/logo-white.svg": 4670
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;